import MapboxGeocoding from './MapboxGeocoding.js';
import MetroCloudAllianceGeocoding from './MetroCloudAllianceGeocoding.js';

/**
 * A geocoding service implementation
 */
class Geocoding {

   constructor() {
      this._initClient(reachMap.geocodingOptions.client);
   }
   /**
    * Initialize the geocoding client
    * @param client - The geocoding client name.
    */
   _initClient(client) {
      if (client == 'mapbox')
         this.geocodingClient = new MapboxGeocoding();
      else if (client == 'metroCloudAlliance')
                              /* Site-Spec MetroCloudAlliance Geocoding Provider */
         this.geocodingClient = new MetroCloudAllianceGeocoding();
      else
         throw new Error("Invalid geocoding client");
   }
   /**
    * Get a place latitude/longitude and name based on some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The geocode request promise object.
    */
   geocode(options, abortController, callbackFct) {
      return (this.geocodingClient.geocode(options.getGeocodeOptions(), abortController, callbackFct));
   }
   /**
    * Search a location using the latitude/longitude and some options.
    * @param {GeocodingOptions} options - The geocoding options.
    * @param {object} abortController
    * @param callbackFct - callback to send the data once it is retrieved.
    * @returns {Promise} The geocode request promise object.
    */
   reverse(options, abortController, callbackFct) {
      return (this.geocodingClient.reverse(options.getReverseOptions(), abortController, callbackFct));
   }
}

export default Geocoding;
